<template>
    <v-container>
        <div v-if="status=='loadding'" id="app" class="center" style="text-align: center">
            <h3>為您訂閱中</h3>
            <div class="loader" ></div>
        </div>
        <div v-if="status==='success'" id="app" class="center" style="text-align: center">
            <h3>訂閱成功</h3>
            <div style="text-align: center;">
                <i style="font-size: 120px; color: red;" class="material-icons">check_circle_outline</i>
            </div>
        </div>
        <div v-if="status==='fail'" id="app" class="center" style="text-align: center">
            <h3>訂閱失敗</h3>
            <div style="text-align: center;">
                <i style="font-size: 120px; color: red;" class="material-icons">remove_circle_outline</i>
            </div>
        </div>
    </v-container>
</template>


<script>
import bus from '../nav/bus'
let lambda_url = process.env.VUE_APP_HOST_URL

export default {
    data(){
        return {
            profile: {},
            status: 'loadding',
            line_id: -1,
            code: '',
            state: '',
            msg: '',
        }
    },
    mounted(){

        // alert(location.href)
        // alert(this.$route.query)
        if(this.$route.query.lid == undefined){
            let lid = this.$route.query['liff.state'].split('lid=')[1].split('&')[0]
            let code = this.$route.query['liff.state'].split('code=')[1].split('&')[0]
            let state = this.$route.query['liff.state'].split('state=')[1]
            
            // console.log("liff.state", this.$route.query['liff.state'])
            // let sp = new URLSearchParams(this.$route.query['liff.state'].split('?')[1])
            // let lid = sp.get('lid');
            // console.log('lid:', lid)
            // let code = sp.get('code');
            // let state = sp.get('state');

            this.initializeLiff(lid)
            return
        }
        else{
            let lid = this.$route.query['lid']
            this.code = this.$route.query['code']
            this.state = this.$route.query['state']
            this.initializeLiff(lid, true)
        }
    },
    methods: {
        initializeLiff(myLiffId, isSecond=false) {
            liff.init({
                    liffId: myLiffId
                })
                .then(() => {
                    if (!liff.isLoggedIn()) {
                        liff.login({
                            redirectUri: location.href
                        });
                        return;
                    }

                    var context = liff.getContext();
                    this.line_id = context.userId

                    if(isSecond)
                        this.redirect()
                })
                .catch((err) => {
                    alert('in inital liff error')
                    alert(err)
                });
        },
        redirect() {
            // alert('start to redirect~~~')
            if(this.status == 'fail')
                return

            let post_data = {
                code: this.code,
                profile: {userId: this.line_id},
                company: this.state,
            }

            axios.post(lambda_url+'/notify_search/', post_data)
            .then(response => {
                var tmp = response.data
                console.log(tmp)
                if(tmp.status === true){
                    this.status = 'success'
                }
                else
                    alert(tmp.msg)
            })
            .catch((error)=> {
            	alert(error)
                console.log(error);
            });
        },
    },
}
</script>

<style>
.loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.center {
    position: fixed; /* or absolute */
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>